<div class="list-sidebar" style="border-left: 0px;">
    <input type="text" [(ngModel)]="searchText" class="form-control input-box" placeholder="Write to search">
    <div class="sidelist">
        
    <ul class="boxscroll">
        <li draggable [dragEnabled]="enableDrag" [dragData]="item" class="side-listli" *ngFor="let item of itemList | appFilter: searchText: searchItem">
            <span *ngIf="showColor" class="alert-w green" [style.background-color]="item.COLOR"></span>
            <a (click)="getSingle(item)">{{item[showItem]}}</a>
    
            <i  *ngIf="showDelete"  class="material-icons-outlined side-delete" style="cursor:pointer;" [tippy]="tpl2"
                [data]="item" variation="popper">delete</i>
    
        </li>    
    </ul>
</div>
    <ng-template #popper let-hide let-item="data"  #tpl2>
                            
        Are you sure you want to delete this item?
        <div class="text-center">
            <button class="btn btn-success btn-sm" (click)="hide();deleteDtl(item)">Yes</button>
            <button class="btn btn-danger  btn-sm" (click)="hide();">No</button>
            
        </div>
    
  </ng-template>
</div>
